import React from 'react';
import Back from '../../../features/back/Back';
import { shelfContent } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';
const { title } = shelfContent;

const ShelfHeader = React.forwardRef(function ShelfHeader({}, ref) {
  const { t } = useTranslation();

  return (
    <div className={`shelf__header`}>
      <Back />
      <h1 className={'shelf__title'}>{t(title)}</h1>
    </div>
  );
});
export default ShelfHeader;
ShelfHeader.propTypes = {};
